import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes,PreloadAllModules } from '@angular/router';
import { InsertClientComponent } from './insert-client/insert-client.component';
import { ClientComponent } from './client/client.component';
import { MethodInsertComponent } from './method-insert/method-insert.component';
import { MachineInsertComponent } from './machine-insert/machine-insert.component';
import { ProductInsertComponent } from './product-insert/product-insert.component';
import { SubjectInsertComponent } from './subject-insert/subject-insert.component';
import { SubjectAccountModalComponent } from './subject-account-modal/subject-account-modal.component';
import { GroupComponent } from './group/group.component';
import { GroupInsertComponent } from './group-insert/group-insert.component';
import { EmployeeComponent } from './employee/employee.component';
import { EmployeeInsertComponent } from './employee-insert/employee-insert.component';
import { RequestComponent } from './request/request.component';
import { RequestInsertComponent } from './request-insert/request-insert.component';
import { LoginComponent } from './login/login.component';
import { SettingsComponent } from './settings/settings.component';
import { IpsComponent } from './ips/ips.component';
import { SystemDataComponent } from './system-data/system-data.component';
import { IndicatorInsertComponent } from './indicator-insert/indicator-insert.component';
import { TechniciansComponent } from './technicians/technicians.component';
import { TicketSystemComponent } from './ticket-system/ticket-system.component';
import { IdentificationInputComponent } from './identification-input/identification-input.component';
import { DocumentComponent } from './document/document.component';
import { DocumentInsertComponent, EditRow } from './document-insert/document-insert.component';
import { AcceptProtocolComponent } from './accept-protocol/accept-protocol.component';
import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';
import { ArchiveRequestComponent } from './archive-request/archive-request.component';
import { ArchivedRequestsComponent } from './archived-requests/archived-requests.component';






const routes: Routes = [
  { path: "", component: LoginComponent },
  { path: 'clientInsert', component: InsertClientComponent },
  { path: 'clientEdit/:id', component: InsertClientComponent },
  { path: 'clients', component: ClientComponent },
  { path: 'requests', component: RequestComponent },
  { path: 'requestInsert', component: RequestInsertComponent },
  { path: 'requestEdit/:id', component: RequestInsertComponent },
  { path: 'groupInsert', component: GroupInsertComponent },
  { path: 'groupEdit/:id', component: GroupInsertComponent },
  { path: 'groups', component: GroupComponent },
  { path: 'employeeInsert', component: EmployeeInsertComponent },
  { path: 'employeeEdit/:id', component: EmployeeInsertComponent },
  { path: 'employees', component: EmployeeComponent },
  { path: 'settings', component: SettingsComponent },
  { path: 'systemData', component: SystemDataComponent},
  { path: 'technicians', component: TechniciansComponent},
  { path: 'tickets', component: TicketSystemComponent},
  { path: 'identification', component: IdentificationInputComponent},
  { path: 'documents', component: DocumentComponent },
  { path: 'documentInsert/:id', component: DocumentInsertComponent },
  { path: 'documentEdit/:id', component: DocumentInsertComponent },
  { path: 'protocols', component: AcceptProtocolComponent },
  { path:"archiveInsert",component:ArchiveRequestComponent}
];
@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes),
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.cubeGrid,
      backdropBackgroundColour: 'rgba(0,0,0,0.1)', 
      backdropBorderRadius: '4px',
      primaryColour: '#ffffff', 
      secondaryColour: '#ffffff', 
      tertiaryColour: '#ffffff',
      fullScreenBackdrop:true
  }),
  RouterModule.forRoot(routes, {
    preloadingStrategy: PreloadAllModules
  }),

  ],
  exports: [RouterModule],
  declarations: []
})

export class AppRoutingModule { }
